<template>
  <div class="WidgetsViewHint">
    <div class="content">
      <div class="content__header">
        Widget to aktywna ikona usługi call web, która po aktywacji pojawi się na Twojej stronie
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Dodaj adres swojej strony internetowej bez http:// i https://
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Umieść widget na swojej stronie internetowej. W tym celu skopiuj kod html i postępuj zgodnie z instrukcjami
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            3
          </div>
        </div>
        <label>
          Widget możesz włączyć lub wyłączyć w dowolnym momencie
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WidgetsViewHint',


};
</script>
